import { Analytics } from '@cobliteam/analytics';
import type { Preferences } from '@cobliteam/common-types';
import { useLocalStorage, useUser } from '@cobliteam/hooks';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import { isSameDay } from '@cobliteam/utils/date';
import { useMemo } from 'react';

const useContractRenewalVisibility = () => {
  const { contractRenewalConfig } = useFeatureFlags();
  const { session } = useUser();
  const [preferences, setPreferences] = useLocalStorage<Preferences>('preferences');

  const fleetId = session?.fleet.id;

  const shouldShow = useMemo(() => {
    if (!(contractRenewalConfig && fleetId)) return false;

    const fleetState = preferences?.contractRenewal?.[fleetId];
    if (fleetState?.alreadySigned) return false;
    if (fleetState?.lastDismissedAt && isSameDay(new Date(), new Date(fleetState.lastDismissedAt))) return false;

    return true;
  }, [contractRenewalConfig, fleetId, preferences?.contractRenewal]);

  const onClose = () => {
    if (!fleetId) return;
    Analytics.track('Contract Renewal - Close For Now', { fleetId });
    setPreferences({
      ...preferences,
      contractRenewal: {
        ...preferences?.contractRenewal,
        [fleetId]: {
          ...preferences?.contractRenewal?.[fleetId],
          alreadySigned: false,
          lastDismissedAt: new Date().toISOString(),
        },
      },
    });
  };

  return { shouldShow, onClose };
};

export default useContractRenewalVisibility;
